import { Group, Skeleton, Stack } from '@mantine/core'

export default function ContactCardSkeleton() {
  return (
    <Group align="flex-start">
      <Skeleton height={60} circle mb="xl" />

      <Stack style={{ flexGrow: 1 }} pt="xs" gap="sm">
        <Stack w="80%" gap={5}>
          <Skeleton height={30} />
          <Skeleton height={20} />
        </Stack>
        <Stack w="80%" gap={5}>
          <Group wrap={'nowrap'} gap={5}>
            <Skeleton height={15} width={15} />
            <Skeleton height={15} />
          </Group>
          <Group wrap={'nowrap'} gap={5}>
            <Skeleton height={15} width={15} />
            <Skeleton height={15} />
          </Group>
        </Stack>
      </Stack>
    </Group>
  )
}
